import { isObject } from "lodash"
import moment from "moment"
import { kycStatus } from "./table"

export const statusOptions = [
  { name: 'Hoạt động', code: true },
  { name: 'Tạm ngưng', code: false }
]


export const accountTypeOptions = [
  { name: 'Người dùng', code: 'regular' },
  { name: 'Môi giới', code: 'broker' }
]

export const initialValuesAccount = (data: any) => {

  return {
    ...data,
    avatar: data.avatar?.url?.medium || data.avatar?.url?.original || '',
    full_address: data.ward ? `${data.ward.name}, ${data.district.name}, ${data.province.name}` : '',
    region_id: data.province_id,
    district_id: data.district_id,
    ward_id: data.ward_id,
    activation_status: statusOptions.find(option => option.code === data.activation_status),
    account_type: accountTypeOptions.find(option => option.code === data.account_type),
  }
}


export const parseFormDataAccount = (data: any) => {

  return {
    id: data?.id || null,
    full_name: data?.full_name || '',
    email: data?.email || '',
    province_id: data?.province_id || null,
    district_id: data?.district_id || null,
    ward_id: data?.ward_id || null,
    profile_image: data?.profile_image || data?.avatar?.uuid || '',
    // package_id: data?.package_id || data?.membership?.id || null,
    // package_expired_at: (data?.package_expired_at && data?.package_id) ? data?.membership_user_plan?.expired_at : '',
    activation_status: isObject(data.activation_status) ? data.activation_status.code : data.activation_status,
    phone_number: data?.phone_number || '',
    account_type: accountTypeOptions.find(option => option.code === data.account_type),
    password: data?.password || '',
    address: data?.address || '',
  }
}

export const initialValuesCreateBOAccount = {
    full_name: "",
    email: "",
    profile_image: "",
    activation_status: true,
    phone_number: "",
    password: "",
    password_confirmation: "",
    permissions: []
}

export const genderOptions = [
  { name: 'Nam', code: 'male' },
  { name: 'Nữ', code: 'female' }
]

export const initialValuesKYC = (data: any) => {
  console.log(data, 'initialValuesKYC');

  return {
    id: data?.id || null,
    user_id: data?.user?.id || null,
    code: data?.user?.code || '',
    birthday: data?.birthday ? moment(data?.birthday, "DD-MM-YYYY").format('DD/MM/YYYY') : '',
    full_name: data?.full_name || '',
    address: data?.address || '',
    region: data?.ward?.name ? `${data.ward.name}, ${data.district.name}, ${data.province.name}` : '',
    front_image_url: data?.front_id_image?.url?.original || '',
    back_image_url: data?.back_id_image?.url?.original || '',
    selfie_image_url: data?.selfie_image?.url?.original || '',
    front_id_image: data?.front_id_image?.uuid || '',
    back_id_image: data?.back_id_image?.uuid || '',
    selfie_image: data?.selfie_image?.uuid || '',
    kyc_status_label: kycStatus(data),
    issue_date: data?.issue_date ? moment(data?.issue_date, "DD-MM-YYYY").format('DD/MM/YYYY') : '',
    expiration_date: data?.expiration_date ? moment(data?.expiration_date, "DD-MM-YYYY").format('DD/MM/YYYY') : '',
    issue_place: data?.issue_place || '',
    national_id_number: data?.national_id_number || '',
    kyc_request_date: data?.kyc_request_date ? moment(data?.kyc_request_date).format('DD/MM/YYYY') : '',
    activation_status: data?.user?.activation_status || false,
    province_id: data?.province_id || null,
    district_id: data?.district_id || null,
    ward_id: data?.ward_id || null,
    gender: genderOptions.find(option => option.code === (data?.gender || data?.user?.gender)),
    hometown: data?.hometown || '',
    province: data?.province || null,
    district: data?.district || null,
    ward: data?.ward || null,
  }
}

const formatToDateTime = (value) => {
  if (!value) return '';

  if (Object.prototype.toString.call(value) === '[object Date]') {
    return moment(value).format('YYYY-MM-DD HH:mm:ss');
  } else if (typeof value === 'string') {
    if (value.includes('/')) {
      return moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD HH:mm:ss');
    } else if (!isNaN(Date.parse(value))) {
      return moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
    }
  }
  return '';
};

export const parseFormDataKYC = (data: any) => {

  return {
    id: data?.id || null,
    front_id_image: data?.front_id_image || '',
    back_id_image: data?.back_id_image || '',
    selfie_image: data?.selfie_image || '',
    full_name: data?.full_name || '',
    birthday: (formatToDateTime(data?.birthday)),
    province_id: data?.province_id || null,
    district_id: data?.district_id || null,
    ward_id: data?.ward_id || null,
    address: data?.address || '',
    national_id_number: data?.national_id_number || '',
    issue_date: (formatToDateTime(data?.issue_date)),
    issue_place: data?.issue_place || '',
    expiration_date: (formatToDateTime(data?.expiration_date)),
    kyc_request_date:(formatToDateTime(data?.kyc_request_date)),
    gender: data?.gender?.code ? data?.gender?.code : data?.gender,
    hometown: data?.hometown || '',
  }
}

export const formDataUpdateAccount = (data: any) => {
  return {
    id: data?.id ?? '',
    code: data.code ?? '',
    full_name: data.full_name ?? '',
    phone_number: data.phone_number ?? '',
    email: data.email ?? '',
    avatar: data.avatar?.url?.medium ?? '',
    password: '',
    activation_status: data.activation_status ?? '',
    password_confirmation: '',
    profile_image: data.profile_image ?? '',
    permissions: data.permissions ?? [],
  }
}

export const initialValuesAccountBO = (acc: any) => {
  console.log(acc, 'initialValuesAccountBO');

  return {
    id: acc.id ?? '',
    code: acc.code ?? '',
    full_name: acc.full_name ?? '',
    phone_number: acc.phone_number ?? '',
    email: acc.email ?? '',
    avatar: acc.avatar?.url?.medium ?? '',
    password: '',
    activation_status: acc.activation_status ?? '',
    password_confirmation: '',
    profile_image: acc.profile_image ?? '',
    permissions: acc.permissions ?? [],
    deleted_at: acc.deleted_at ?? null,
  }
}